
export const menuItems = [
    {
        id: 1,
        label: 'module.user',
        icon: 'mdi mdi-account',
        subItems: [
            {
                id: 29,
                label: 'module.user',
                link: '/user'
            },
            {
                id: 2,
                label: 'module.role',
                link: '/role'
            },
            {
                id: 3,
                label: 'module.passwordReset',
                link: '/password-reset'
            },
        ]
    },
    {
        id: 28,
        label: 'module.configuration',
        icon: 'dripicons-gear',
        subItems: [
            {
                id: 4,
                label: 'module.activeIngredient',
                icon: 'mdi mdi-account',
                link: '/AI'
            },
            {
                id: 5,
                label: 'module.brand',
                icon: 'mdi mdi-account',
                link: '/brand'
            },
            {
                id: 6,
                label: 'module.category',
                icon: 'mdi mdi-account',
                link: '/category'
            },
            {
                id: 7,
                label: 'module.class',
                icon: 'mdi mdi-account',
                link: '/class'
            },
            {
                id: 8,
                label: 'module.form',
                icon: 'mdi mdi-account',
                link: '/form'
            },
            {
                id: 9,
                label: 'module.moa',
                icon: 'mdi mdi-account',
                link: '/moa'
            },
            // {
            //     id: 10,
            //     label: 'module.printerProof',
            //     icon: 'mdi mdi-account',
            //     link: '/printer-proof-status'
            // },
            {
                id: 11,
                label: 'module.purpose',
                icon: 'mdi mdi-account',
                link: '/purpose'
            },
            // {
            //     id: 12,
            //     label: 'module.queryStatus',
            //     icon: 'mdi mdi-account',
            //     link: '/query-status'
            // },
            // {
            //     id: 13,
            //     label: 'module.registrationStatus',
            //     icon: 'mdi mdi-account',
            //     link: '/registration-status'
            // },
            // {
            //     id: 14,
            //     label: 'module.riskStatus',
            //     icon: 'mdi mdi-account',
            //     link: '/risk-status'
            // },
            {
                id: 15,
                label: 'module.source',
                icon: 'mdi mdi-account',
                link: '/source'
            },
            {
                id: 16,
                label: 'module.status',
                icon: 'mdi mdi-account',
                link: '/status'
            },
            {
                id: 17,
                label: 'module.type',
                icon: 'mdi mdi-account',
                link: '/type'
            },
        ]
    },
    {
        id: 29,
        label: 'module.product',
        icon: 'mdi mdi-test-tube-empty',
        subItems: [
            {
                id: 18,
                label: 'module.product',
                icon: 'mdi mdi-account',
                link: '/product'
            },
            {
                id: 30,
                label: 'module.discountinue',
                icon: 'mdi mdi-account',
                link: '/product-discountinue'
            },
            {
                id: 31,
                label: 'module.halex',
                icon: 'mdi mdi-account',
                link: '/product-halex'
            },
            {
                id: 32,
                label: 'module.document',
                icon: 'mdi mdi-account',
                link: '/product-document'
            },
            {
                id: 19,
                label: 'module.productAI',
                icon: 'mdi mdi-account',
                link: '/product-ai'
            },
            {
                id: 20,
                label: 'module.productLabel',
                icon: 'mdi mdi-account',
                link: '/product-label'
            },
            {
                id: 21,
                label: 'module.productPayment',
                icon: 'mdi mdi-account',
                link: '/product-payment'
            },
            {
                id: 22,
                label: 'module.printerProof',
                icon: 'mdi mdi-account',
                link: '/product-printer-proof'
            },
            {
                id: 23,
                label: 'module.query',
                icon: 'mdi mdi-account',
                link: '/product-query'
            },
            {
                id: 24,
                label: 'module.recommendation',
                icon: 'mdi mdi-account',
                link: '/product-recommendation'
            },
            {
                id: 25,
                label: 'module.productRegisterationCertification',
                icon: 'mdi mdi-account',
                link: '/product-cert'
            },
            {
                id: 26,
                label: 'module.productSource',
                icon: 'mdi mdi-account',
                link: '/product-source'
            },
            {
                id: 27,
                label: 'module.productSNS',
                icon: 'mdi mdi-account',
                link: '/product-sns'
            },
             {
                id: 28,
                label: 'module.productMoa',
                icon: 'mdi mdi-account',
                link: '/product-moa'
            },
        ]
    },
   
]